import { useState, useEffect } from "react";
import AdminLayout from "../../../components/Shared/AdminLayout";
import Container from "../../../components/Shared/Container";
import ActionBar from "../../../components/Shared/ActionBar";

function Home(props) {
    return (
        <AdminLayout>
            <ActionBar title="Dashboard" showSearch={false} />
            <Container>
                <div className="space-y-6">
                    {/* Welcome Section */}
                    <div className="bg-eerie-black border border-zinc-700 rounded-3xl p-8">
                        <h1 className="text-3xl font-bold text-white mb-4">Welcome to Admin Dashboard</h1>
                        <p className="text-zinc-400 text-lg">Manage your brands, wallets, and categories from here.</p>
                    </div>

                    {/* Quick Stats Grid */}
                    <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                        <div className="bg-eerie-black border border-zinc-700 rounded-2xl p-6">
                            <div className="flex items-center justify-between">
                                <div>
                                    <p className="text-sm text-zinc-500 uppercase mb-2">Total Brands</p>
                                    <p className="text-3xl font-bold text-white">24</p>
                                </div>
                                <div className="w-12 h-12 bg-charleston-green rounded-full flex items-center justify-center">
                                    <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
                                    </svg>
                                </div>
                            </div>
                        </div>

                        <div className="bg-eerie-black border border-zinc-700 rounded-2xl p-6">
                            <div className="flex items-center justify-between">
                                <div>
                                    <p className="text-sm text-zinc-500 uppercase mb-2">Active Wallets</p>
                                    <p className="text-3xl font-bold text-white">3</p>
                                </div>
                                <div className="w-12 h-12 bg-charleston-green rounded-full flex items-center justify-center">
                                    <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z" />
                                    </svg>
                                </div>
                            </div>
                        </div>

                        <div className="bg-eerie-black border border-zinc-700 rounded-2xl p-6">
                            <div className="flex items-center justify-between">
                                <div>
                                    <p className="text-sm text-zinc-500 uppercase mb-2">Categories</p>
                                    <p className="text-3xl font-bold text-white">12</p>
                                </div>
                                <div className="w-12 h-12 bg-charleston-green rounded-full flex items-center justify-center">
                                    <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2V6zM14 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2V6zM4 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2v-2zM14 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2v-2z" />
                                    </svg>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Recent Activity */}
                    <div className="bg-eerie-black border border-zinc-700 rounded-3xl p-6">
                        <h3 className="text-lg font-semibold text-white mb-4">Recent Activity</h3>
                        <div className="space-y-3">
                            <div className="flex items-center justify-between py-3 border-b border-zinc-800">
                                <div className="flex items-center space-x-3">
                                    <div className="w-2 h-2 bg-green-500 rounded-full"></div>
                                    <div>
                                        <p className="text-white">Wallet balance updated</p>
                                        <p className="text-sm text-zinc-500">PineLabs - ₹1,24,00,000</p>
                                    </div>
                                </div>
                                <span className="text-sm text-zinc-500">2 hours ago</span>
                            </div>
                            
                            <div className="flex items-center justify-between py-3 border-b border-zinc-800">
                                <div className="flex items-center space-x-3">
                                    <div className="w-2 h-2 bg-blue-500 rounded-full"></div>
                                    <div>
                                        <p className="text-white">New brand added</p>
                                        <p className="text-sm text-zinc-500">Amazon Shopping</p>
                                    </div>
                                </div>
                                <span className="text-sm text-zinc-500">5 hours ago</span>
                            </div>
                            
                            <div className="flex items-center justify-between py-3">
                                <div className="flex items-center space-x-3">
                                    <div className="w-2 h-2 bg-purple-500 rounded-full"></div>
                                    <div>
                                        <p className="text-white">Category updated</p>
                                        <p className="text-sm text-zinc-500">Electronics</p>
                                    </div>
                                </div>
                                <span className="text-sm text-zinc-500">1 day ago</span>
                            </div>
                        </div>
                    </div>
                </div>
            </Container>
        </AdminLayout>
    );
}

export default Home;